$(function () {
    $.fn.isInViewport = function () {
        const element_top = $(this).offset().top;
        const element_bottom = element_top + $(this).outerHeight();
        const viewport_top = $(window).scrollTop();
        const viewport_bottom = viewport_top + window.innerHeight;

        return (element_bottom > viewport_top && element_top < viewport_bottom);
    };

    let last_scroll_top = 0;

    $(window).on('scroll resize', function () {
        const has_scroll = (document.body.scrollHeight > document.body.clientHeight);
        const release_item_visible_count = $('#changelog_page .release_item:visible').length;
        const scroll_top = $(this).scrollTop();

        if (has_scroll) {
            if (scroll_top > last_scroll_top) {
                if ($('#changelog_page .release_item:nth-of-type(' + release_item_visible_count + ')').isInViewport()) {
                    $('#changelog_page > .release_item:nth-of-type(n + ' + (release_item_visible_count + 1) + ')').show();
                    $('#changelog_page > .release_item:nth-of-type(n + ' + (release_item_visible_count + 2) + ')').hide();
                }
            } else {
                if (!$('#changelog_page .release_item:nth-of-type(11)').isInViewport() && !$('#changelog_page .release_item:nth-of-type(' + release_item_visible_count + ')').isInViewport()) {
                    $('#changelog_page > .release_item:nth-of-type(n + ' + (release_item_visible_count) + ')').hide();
                }
            }

            last_scroll_top = scroll_top;
        } else {
            $('#changelog_page > .release_item:nth-of-type(n + ' + (release_item_visible_count + 1) + ')').show();
            $('#changelog_page > .release_item:nth-of-type(n + ' + (release_item_visible_count + 2) + ')').hide();

            $(window).trigger('resize');
        }
    });
});
